// extracted by mini-css-extract-plugin
export default {"wrapper":"sr-z","response":"tr-z","error":"ur-z","disabled":"vr-z","buttons":"wr-z","feedbackQuestionSection":"xr-z","yesNoWrapper":"yr-z"};